import AboutItem from "../AboutItem";
import pizzaIcon from "../../../../../assets/img/icons/shapes/pizza.svg";
import ActionTextIconAnchor from "../../../../common/Anchors/ActionTextIconAnchor";
import DesignTogetherThumbnail from "../../../../../assets/img/other/gps.webp";

export default function DesignTogether() {
    return (
        <AboutItem
            heading="We help you get it right from the start."
            thumbnail={DesignTogetherThumbnail}
            floatingIcon={
                <div className="zindex-3 d-none d-lg-block position-absolute top-0 end-0 translate-middle-y w-auto pe-1 me-4">
                    <div data-aos="fade-up" data-aos-duration="950" data-aos-offset="280" className="aos-init">
                        <img src={pizzaIcon} alt="Pizza Icon" width="107" />
                    </div>
                </div>
            }
        >
            { /* About Item Content. */}
            <div className="about-copy">
                <p>
                    Moving to a new system is an important step. We work with you to understand your processes, prepare your setup and data, and train your team.
                </p>
                <p>
                    From the first conversation through to everyday use, our team supports the transition and helps you make equi-track work for your business.
                </p>
                <ActionTextIconAnchor title="Talk to us about getting started" path="/#contact" />
            </div>
        </AboutItem>    
    )
}
